
import { useEffect } from 'react';
import Header from '@/components/Header';
import FooterSection from '@/components/FooterSection';
import AdvisoryHero from '@/components/advisory/AdvisoryHero';
import AdvisoryTopics from '@/components/advisory/AdvisoryTopics';
import AdvisoryValueProposition from '@/components/advisory/AdvisoryValueProposition';
import AdvisoryOptions from '@/components/advisory/AdvisoryOptions';
import AdvisoryCta from '@/components/advisory/AdvisoryCta';
import AdvisoryFaq from '@/components/advisory/AdvisoryFaq';

const Advisory = () => {
  useEffect(() => {
    // Update document title
    document.title = 'AI Advisory Services | DocketLabs';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert AI advisory services for legal professionals. Get guidance on tools, implementation & best practices. Schedule your consultation.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Expert AI advisory services for legal professionals. Get guidance on tools, implementation & best practices. Schedule your consultation.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
    
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow bg-background text-foreground">
        <AdvisoryHero />
        <AdvisoryValueProposition />
        <AdvisoryOptions />
        <AdvisoryCta />
        <AdvisoryFaq />
      </main>
      <FooterSection />
    </div>
  );
};

export default Advisory;
